import { baseAPI } from "./baseService";
import { MALSAPI, POINTING } from "./serviceConstants";

export const pointingSourcesAPI = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getMetadata: builder.query({
      query: (pointingId) => `${MALSAPI}/${POINTING}/${pointingId}/metadata`,
      providesTags: ["metadata"],
    }),
    updateConfig: builder.mutation({
      query: ({config,catId}) => {
        return {
          url: `${MALSAPI}/${POINTING}/config`,
          params:{catalogue_id:catId},
          method: "PUT",
          body: config,
        };
      },
    }),
    bulkSourceStitch: builder.mutation({
      query: ({stitchOptions,catId}) => {
        return {
          url: `${MALSAPI}/${POINTING}/bulk_stitch`,
          params:{catalogue_id:catId},
          method: "POST",
          body:stitchOptions
        };
      },
      invalidatesTags: [
        "catalogues",
        // "metadata",
        "spws",
        "source",
        "pointingsources",
      ],
    }),

    getRefSpwAndSeparation:builder.query({
      query: (catalogueId) => {
        return { url: `${MALSAPI}/${POINTING}/reference_spw`, params: { catalogue_id:catalogueId } }
    },

      // providesTags: ["metadata"],
    }),
    gaussDownload: builder.mutation({
      query: ({pointingId, sourceIds,catalogueId}) => {
        return {
          url: `${MALSAPI}/${POINTING}/${pointingId}/gauss/download`,
          params:{catalogue_id:catalogueId},
          method: "POST",
          body: sourceIds,
          responseHandler: (response) => response.text()
        };
      }
    }),
    getPointingSourcesByCatalogueId: builder.query({
      query: (arg) => {
        const { pointingId, spw ,catalogueId} = arg;
        if (spw) return { url: `${MALSAPI}/${POINTING}/${pointingId}/sources`, params: { spw,catalogue_id:catalogueId } };
        return { url: `${MALSAPI}/${POINTING}/${pointingId}/sources`, params: { catalogue_id:catalogueId } };
      },
      // providesTags: ["pointingsources"],
    }),

    bulkRefreshSources: builder.mutation({
      query: ({refreshOptions,catalogueId}) => {
        return {
          url: `${MALSAPI}/${POINTING}/bulk_refresh`,
          params:{catalogue_id:catalogueId},
          method: "POST",
          body: refreshOptions,
        };
      },
      invalidatesTags:["spws","spectralspws"]
    }),
    bulkRefreshSpectral: builder.mutation({
      query: ({refreshOptions,catId}) => {
        return {
          url: `${MALSAPI}/${POINTING}/bulk_spectral_refresh`,
          params:{catalogue_id:catId},
          method: "POST",
          body: refreshOptions,
        };
      },
    }),

    getHistoryUpdates: builder.query({
      queryFn: async ({sessionId,catalogueId}) => ({
          data: [],
      }),
      async onCacheEntryAdded(
          _arg,
          { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
      ) {
          try {
            const evtSource = new EventSource(`${window.location.origin}/mals/api/pointing/changelog?catalogue_id=${_arg.catalogueId}`);
            await cacheDataLoaded;

              const listener = (event) => {
                  // let data=JSON.stringify(event.data).replaceAll("\n","\\n")
                  let parsedData = JSON.parse(event.data);

                  updateCachedData((draft) => {
                    draft=[...parsedData];
                     let sortedData=draft.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
                    //  if (sortedData[0].status === 'COMPLETED') {
                    //    evtSource.close();
                    //  }
                     if (sortedData.every(dataObj=>dataObj.status==='COMPLETED')) {
                      evtSource.close();
                    }
                     return sortedData;
                  })


              };

              evtSource.addEventListener('message', listener);
              await cacheEntryRemoved;
              evtSource.close();

          } catch (e) {
              console.log('exception',e);
          }

      },
  }),

  }),
});

export const {
  useGetMetadataQuery,
  useUpdateConfigMutation,
  useGaussDownloadMutation,
  useGetPointingSourcesByCatalogueIdQuery,
  useBulkRefreshSourcesMutation,
  useGetHistoryUpdatesQuery,
  useLazyGetHistoryUpdatesQuery,
  useBulkSourceStitchMutation,
  useBulkRefreshSpectralMutation,
  useGetRefSpwAndSeparationQuery
} = pointingSourcesAPI;
